/*
document.addEventListener("DOMContentLoaded", function () {    
    const mobileMaxWidth = 768;
    if (window.innerWidth <= mobileMaxWidth) {
      const accordions = document.querySelectorAll('.widget-title-accordion, .widget-title');
      accordions.forEach(function (accordion) {
        accordion.addEventListener('click', function () {
          const content = this.nextElementSibling;
          if (content) {            
            content.style.display = (content.style.display === "block") ? "none" : "block";
            content.style.marginTop = (content.style.display === "block") ? "20px" : "0px";
          }
          this.classList.toggle('active');
        });
      });
    }else{
      const footerAccordionNo = document.querySelectorAll('.footer-accordion');
      footerAccordionNo.style.display = (content.style.display === "block") ? "block" : "none";
    }
  });
*/
  document.addEventListener("DOMContentLoaded", function () {    
  const mobileMaxWidth = 768;

  if (window.innerWidth <= mobileMaxWidth) {
    const accordions = document.querySelectorAll('.widget-title-accordion, .widget-title');

    accordions.forEach(function (accordion) {
      accordion.addEventListener('click', function () {
        const content = this.nextElementSibling;

        if (content) {            
          const isOpen = content.style.display === "block";

          content.style.display = isOpen ? "none" : "block";
          content.style.marginTop = isOpen ? "0px" : "20px";
        }

        this.classList.toggle('active');
      });
    });

  } else {
    const footerAccordions = document.querySelectorAll('.footer-accordion');

    footerAccordions.forEach(function(item) {
      item.style.display = "block"; // always show on desktop
      item.style.marginTop = "0px";
    });
  }
});